import {GlobalAnalyticsVariablesInterface, TrackInlineAlertInterface} from '../interfaces';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackInlineAlertPayloadCase = (
  payload: any,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackInlineAlertInterface => {
  const data = {
    ...payload,
    channel: payload.channel,
    currentPage: payload.currentPage,
    errorMsg: payload.errorMsg,
    eventType: payload.eventType,
    interaction: payload.interaction,
    pageName: payload.currentPage,
  };
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
};
